import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useFetchCompanyListQuery } from "../../../../../utils/company/companySelector";
import { closeSideDrawer } from "../../../../../utils/permissionSlice";
import { useDispatch } from "react-redux";

export const CompanyHeader = ({ companyName, logoSrc }) => {
  // const { data: companyCommnData, error, isLoading, refetch } = useFetchCompanyListQuery(tokens);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useLocation();
  const isAddCompany = params.pathname.split("/")[1] === "onboard_company";

  const handleNavigateDashboard = () => {
    navigate("/companyDashboard");
  };
  const handleAddCompany = () => {
    navigate("/onboard_company/general-info");
    dispatch(closeSideDrawer());
  };

  return (
    <div className="flex flex-wrap gap-4 pt-4 items-center justify-between text-2xl font-bold tracking-wide leading-none text-primary">
      {/* <img
        src={logoSrc}
        className="object-contain shrink-0 self-stretch my-auto w-7 aspect-square"
        alt="Company logo"
      /> */}
      <h1 className="text-2xl self-stretch my-auto">{companyName}</h1>
      {!isAddCompany && (
        <div className="flex items-center justify-center gap-x-2">
          {/* <button
            onClick={handleAddCompany}
            className="px-3 py-2 bg-primary-90 hover:bg-primary text-[#FFF] cursor-pointer font-500 text-sm rounded-md"
          >
            Add Company
          </button> */}
          <button
            onClick={handleNavigateDashboard}
            className="px-3 py-2 bg-primary-90 hover:bg-primary text-[#FFF] cursor-pointer font-500 text-sm rounded-md"
          >
            View Dashboard
          </button>
        </div>
      )}
    </div>
  );
};
